<template>
    <div class="loading_status">
        <div class="spinner">
          	<h3>{{ text ? text : '暂无该资源' }}</h3>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    export default{
		props:['type','text'],
		created(){

		},
		methods:{
			
		}
    }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .loading_status{
        width: 100vw;
        overflow: hidden;
        h3{
			font-size: 30px/$ppr;
			color: #999;
			line-height: 60px/$ppr;
			text-align: center;
			bottom: -80px/$ppr;
			position: absolute;
            width: 160%;
            left: -30%;
        }
    }
    .spinner {
        position: absolute;
        top: 40%;
        left:50%;
        width: 196px/$ppr;
        height: 200px/$ppr;
        margin-top: -98px/$ppr;
        margin-left: -100px/$ppr;
        background: url("./img/noResourse.png") no-repeat;
        background-size: 100% 100%;
    }
</style>
